import React from 'react';
import {Form} from 'semantic-ui-react';
import {injectIntl, intlShape} from 'react-intl';

import {isNoU, makeDBContentImageUrl} from "utils/DBUtils";
import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveDropdown extends React.Component {

  getValueFromOnChange = (event, data) => {
    return data.value;
  };

  get options() {
    return this.props.options || [];
  }

  render() {
    let options = this.options.map((item) => {
      let t = item.text || (item.textKey ? this.props.intl.formatMessage({id: item.textKey}) : "");
      return ({
        value: item.value,
        text: t,
        image: item.imageId ? makeDBContentImageUrl(item.imageId) : ""
      })
    });
    return (
        <AutoSaveField  {...this.props}
                        control={Form.Dropdown}
                        options={options}
                        currentPlatform={this.props.currentPlatform}
                        getValueFromOnChange={this.getValueFromOnChange}
                        supportsLoading={true}
                        name={this.props.name}
                        helpHeader={this.props.helpHeader}
                        helpContent={this.props.helpContent}
                        onValidationError={this.props.onValidationError}
                        onValidationSuccess={this.props.onValidationSuccess}
                        selection={true} />
    );
  }
}

AutoSaveDropdown.propTypes = {
    intl: intlShape,
    // options: PropTypes.arrayOf(PropTypes.shape({
    //     text: PropTypes.string.isRequired,
    //     value: PropTypes.any.isRequired
    // }))
};

AutoSaveDropdown.defaultProps = {
    // options: []
};

export default injectIntl(AutoSaveDropdown);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveDropdown.jsx